import React from 'react';
import {
  Button,
  Col,
  Form,
  InputNumber,
  Modal,
  Row,
  Typography,
  notification,
} from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Logger } from 'stores/Classes';

const DarkHeaderModal = styled(Modal)`
  & {
    width: 20% !important;

    @media (max-width: 1615px) {
      width: 30% !important;
    }

    @media (max-width: 1366px) {
      width: 40% !important;
    }

    @media (max-width: 1024px) {
      width: 50% !important;
    }

    @media (max-width: 768px) {
      width: 70% !important;
    }
  }

  .ant-modal-content {
    .ant-modal-close {
      .ant-modal-close-x {
        color: #05103a;
      }
    }

    .ant-modal-header {
      .ant-modal-title {
        color: #05103a;
      }
    }
  }

  .footer-row {
    margin-top: 21px !important;

    .ant-col {
      display: flex;
      justify-content: flex-end;
    }
  }

  .save-btn {
    margin-left: 8px;
  }
`;

const StyledFormContainer = styled.div`
  padding: 5px;

  .ant-form {
    .ant-col-12 {
      .ant-form-item {
        margin: 0;
      }
    }

    .ant-form-item-label {
      line-height: 10px;
    }
  }
`;

const ExpiringSoonStatusFormContent = ({
  onSubmit,
  onCancel,
  saving,
  initialData,
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      await form.validateFields();
      onSubmit(values);
    } catch (error) {
      Logger.error('Error saving preferences', error);
      notification.error({
        message: 'Error',
        description: 'An error occurred while saving your settings',
      });
    }
  };

  return (
    <StyledFormContainer>
      <Form
        form={form}
        onFinish={handleSubmit}
        initialValues={{
          warrantyStatusChangeDays: initialData?.warrantyStatusChangeDays,
          warrantyStatusChangeMiles: initialData?.warrantyStatusChangeMiles,
        }}
      >
        <Typography.Text
          style={{
            display: 'block',
            marginBottom: 16,
            fontWeight: 'bold',
            padding: '9px 9px 1px 0',
          }}
        >
          Warranties Expiring Soon status shows when time or mileage is less
          than:
        </Typography.Text>

        <Row gutter={[8, 8]}>
          <Col span={10}>
            <Form.Item
              label="Days"
              name="warrantyStatusChangeDays"
              rules={[{ required: true, message: 'Please fill this field' }]}
              layout="vertical"
            >
              <InputNumber
                placeholder="30"
                style={{ width: '100%' }}
                allowClear
              />
            </Form.Item>
          </Col>

          <Col
            span={4}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              paddingTop: '28px',
            }}
          >
            <Typography.Text>OR</Typography.Text>
          </Col>

          <Col span={10}>
            <Form.Item
              label="Mileage"
              name="warrantyStatusChangeMiles"
              rules={[{ required: true, message: 'Please fill this field' }]}
              layout="vertical"
            >
              <InputNumber
                placeholder="1000"
                style={{ width: '100%' }}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[8, 8]} style={{ marginTop: '30px' }}>
          <Col span={24}>
            <Button
              type="primary"
              style={{ float: 'right', marginLeft: 8 }}
              htmlType="submit"
              loading={saving}
            >
              Save
            </Button>
            <Button
              style={{ float: 'right' }}
              htmlType="button"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
    </StyledFormContainer>
  );
};

ExpiringSoonStatusFormContent.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  saving: PropTypes.bool,
  initialData: PropTypes.object,
};

const StatusSettingsModal = ({
  visible = false,
  saving = false,
  initialData = {},
  onOk = () => {},
  onCancel = () => {},
}) => {
  const handleFormSubmit = (data) => {
    onOk(data);
  };

  return (
    <DarkHeaderModal
      open={visible}
      onCancel={onCancel}
      title="Status Settings"
      footer={null}
    >
      <ExpiringSoonStatusFormContent
        initialData={initialData}
        saving={saving}
        onSubmit={handleFormSubmit}
        onCancel={onCancel}
      />
    </DarkHeaderModal>
  );
};

StatusSettingsModal.propTypes = {
  visible: PropTypes.bool,
  saving: PropTypes.bool,
  initialData: PropTypes.object,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
};

export default StatusSettingsModal;
